export class SynchronizationFilter {
    synchroId = '0';

    constructor() {
        this.synchroId = '0';
    }
    initFromJson(json) {
        this.synchroId = json.synchroId;
    }

    isEmpty() {

        return this.synchroId.length === 0;
    }
}
